import { connect } from 'react-redux';

import { WixConnect } from 'shared/utils/wix-connect';

import { canShowMainItemPublisher, canShowMainItemTitle } from 'shared/selectors/app-settings';

import SubscribeShownBIOverlay from '../bi/_subscribe-shown-bi-overlay';
import Button from 'widget/components/button/button';
import Icon from 'shared/components/icon/icon';

import styles from './classic.styl';


@connect(state => ({
  canShowMainItemTitle: canShowMainItemTitle(state),
  canShowMainItemPublisher: canShowMainItemPublisher(state),
}))
@WixConnect(styles)
export default class OverlayClassicCenter extends SubscribeShownBIOverlay {

  static displayName = 'OverlayClassicCenter';

  get playButton() {
    const playButtonText = this.playButtonText;

    if (!playButtonText) {
      return null;
    }

    return (
      <Button className="qa-widget-overlay-play-button"
              styleName="button"
              onClick={this.playSelectedVideo}>
        <Icon styleName="play-icon"
              name="arrow-right-filled" />
        <span>
          {playButtonText}
        </span>
      </Button>
    );
  }

  get playNextButton() {
    const playNextButtonText = this.playNextButtonText;

    if (!playNextButtonText) {
      return null;
    }

    return (
      <Button styleName="button"
              onClick={this.playNextVideo}>
        {playNextButtonText}
        <Icon styleName="next-icon"
              name="arrow-right" />
      </Button>
    );
  }

  get subscribeButton() {
    const subscribeButtonText = this.subscribeButtonText;

    if (!subscribeButtonText) {
      return null;
    }

    return (
      <Button styleName="button"
              className="qa-widget-overlay-subscribe-button"
              onClick={this.openSubscription}>
        {subscribeButtonText}
      </Button>
    );
  }

  get purchaseButton() {
    const purchaseButtonText = this.purchaseButtonText;

    if (!purchaseButtonText) {
      return null;
    }

    return (
      <Button className="qa-widget-overlay-buy-from-button"
              styleName="button"
              onClick={this.openPurchase}>
        {purchaseButtonText}
      </Button>
    );
  }

  get buttons() {
    if (!this.props.videoItem) {
      return null;
    }

    return (
      <div styleName="buttons">
        {this.playButton}
        {this.subscribeButton || this.purchaseButton}
        {this.playNextButton}
      </div>
    );
  }

  render() {
    const { className } = this.props;

    const styles = this.getOpacityStyles();

    return (
      <div style={styles}
           styleName="overlay"
           className={`qa-player-overlay ${className}`}
           data-hook="playerOverlay"
           onClick={this.playSelectedVideo}>
        {this.title}
        {this.publisher}
        {this.buttons}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/player-overlay/classic/center.js